"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Loader } from "lucide-react";
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="222192" className="flex flex-col items-center justify-center py-16 text-center animate-in fade-in duration-700">
        <div className="w-16 h-16 mb-6 rounded-full border-2 border-chart-1 flex items-center justify-center">
          <svg className="w-8 h-8 text-chart-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h3 className="text-2xl font-default text-foreground mb-4">Vielen Dank!</h3>
        <p className="text-foreground/70 font-default mb-8 max-w-md">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="rounded-full border-chart-1 text-chart-1 hover:bg-chart-1 hover:text-primary-foreground transition-colors px-8">
          Weitere Nachricht senden
        </Button>
      </div>;
  }
  const inputStyles = "peer border-0 border-b border-foreground/20 rounded-none px-0 py-4 h-auto focus-visible:ring-0 focus-visible:border-chart-1 bg-transparent placeholder-transparent focus:placeholder-muted-foreground/50 text-foreground shadow-none font-default text-lg transition-colors resize-none";
  const labelStyles = "absolute left-0 top-4 text-foreground/60 font-default text-lg transition-all duration-300 peer-focus:-translate-y-2 peer-focus:opacity-0 peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:opacity-0 pointer-events-none";
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <FormField control={control} name="name" rules={{
      required: "Ihr Name wird benötigt"
    }} render={({
      field
    }) => <FormItem className="relative pt-2">
            <FormControl>
              <Input {...field} className={inputStyles} placeholder="Max Mustermann" />
            </FormControl>
            <FormLabel className={labelStyles}>Ihr Name</FormLabel>
            <FormDescription className="sr-only">Vor- und Nachname</FormDescription>
            <FormMessage className="absolute -bottom-6 text-xs text-destructive" />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "E-Mail-Adresse wird benötigt",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Bitte geben Sie eine gültige E-Mail-Adresse ein"
      }
    }} render={({
      field
    }) => <FormItem className="relative pt-2">
            <FormControl>
              <Input {...field} type="email" className={inputStyles} placeholder="name@beispiel.de" />
            </FormControl>
            <FormLabel className={labelStyles}>E-Mail-Adresse</FormLabel>
            <FormMessage className="absolute -bottom-6 text-xs text-destructive" />
          </FormItem>} />

      <FormField control={control} name="phone" rules={{
      pattern: {
        value: /^[0-9\-\+\s\(\)]*$/,
        message: "Bitte geben Sie eine gültige Telefonnummer ein"
      }
    }} render={({
      field
    }) => <FormItem className="relative pt-2">
            <FormControl>
              <Input {...field} type="tel" className={inputStyles} placeholder="+49 123 456789" />
            </FormControl>
            <FormLabel className={labelStyles}>Telefonnummer</FormLabel>
            <FormDescription className="absolute right-0 top-4 text-xs text-muted-foreground pointer-events-none peer-focus:opacity-0 transition-opacity">
              Optional
            </FormDescription>
            <FormMessage className="absolute -bottom-6 text-xs text-destructive" />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Bitte beschreiben Sie kurz Ihr Vorhaben"
    }} render={({
      field
    }) => <FormItem className="relative pt-2">
            <FormControl>
              <Textarea {...field} className={`${inputStyles} min-h-[120px]`} placeholder="Erzählen Sie uns von Ihrem Projekt..." />
            </FormControl>
            <FormLabel className={labelStyles}>Ihr Vorhaben (z.B. Baumfällung, Baubegleitung)</FormLabel>
            <FormMessage className="absolute -bottom-6 text-xs text-destructive" />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 text-destructive text-sm text-center rounded-md">
          {submitError}
        </div>}

      <div className="pt-8">
        <Button type="submit" disabled={isSubmitting} className="w-full h-14 rounded-full bg-chart-1 text-primary-foreground hover:bg-chart-1/90 text-lg font-default tracking-wide transition-all shadow-lg hover:shadow-xl">
          {isSubmitting ? <>
              <Loader className="mr-2 h-5 w-5 animate-spin" />
              Wird gesendet...
            </> : 'Kostenlose Einschätzung anfordern'}
        </Button>
      </div>
    </Form>;
}
export default function GetInTouch() {
  return;
}